import React from 'react'
import TableCustomer from './components/TableCustomer'
import { PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'

function SwitchProfile() {
     // const intl = useIntl()
     return (
          <>
               <PageTitle breadcrumbs={[]}>Switch profile</PageTitle>
               <TableCustomer className='card-xl-stretch mb-xl-8' />
          </>
     )
}

export default SwitchProfile